<base-support-modal [title]="title" [btnOkClass]="inFreemiumMode ? 'btn-danger' : 'btn-success'" [btnOkLabel]="inFreemiumMode ? 'Удалить' : 'Назначить'" (onOk)="ok()" >
	<p>
		{{inFreemiumMode ? 'Убрать' : 'Назначить'}}  <mark>freemium</mark>-режим для сайта?
	</p>
</base-support-modal>
